import React, { useState } from 'react'
import { useHistory, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { CustomButton, GoogleAuthButton } from 'components'
import { Form, Input } from 'antd'
import { login } from 'modules/session/session-actions'
import { goAfterSignIn } from 'utils/sessionSharing'
import './index.styl'

const { Item } = Form

const FormSignIn = ({ title = '', redirectTo, onSignUpClick }) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const onFinish = form => {
    setLoading(true)
    const data = {
      email: form.email.trim(),
      password: form.password,
      role: 'customer',
      deviceType: 'WEB',
    }
    const callback = () => {
      setLoading(false)
      window.dataLayer.push({ event: 'login-success' })
    }
    dispatch(login(data, callback, true)).then(data => data?.isVenueUser ? history.push(`/venue/${data?.venueUrl}`) : goAfterSignIn(history, redirectTo)).catch(() => setLoading(false))
  }

  const resetPassword = () => history.push('/auth/reset-password')

  return (
    <div className='wrapperFormSignInModal'>
      <div className='title'>{title}</div>
      <Form layout='vertical' className='form' onFinish={onFinish}>
        <Item
          name='email' label='Email or Username'
          rules={[{ required: true, whitespace: true, message: 'Please enter email or username' }]}
          validateTrigger='onBlur'
        >
          <Input className='input' />
        </Item>
        <Item
          name='password'
          label='Password'
          rules={[
            { required: true, message: 'Please enter password' },
            { min: 6, message: 'Password must be at least 6 characters.', transform: value => value?.trim() },
          ]}
          validateTrigger='onBlur'
        >
          <Input.Password className='input' />
        </Item>

        <div className='link' onClick={resetPassword}>Forgot Password</div>
        <div className='wrapperActions'>
          <CustomButton text='Log In' type='dark' className='btn' htmlType='submit' loading={loading} />
        </div>
        <GoogleAuthButton onAuthSuccess={() => {}} />
        <div className='linkToSignUpWrapper'>
          <div className='noAccountTitle'>Don’t have an account?</div>
          {onSignUpClick
            ? <div className='signUpButtonLink' onClick={onSignUpClick}>Sign Up</div>
            : <Link className='signUpButtonLink' to='/auth/sign-up'>Sign Up</Link>}
        </div>
      </Form>
    </div>
  )
}

export default FormSignIn
